(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anywell-ad-ys16max20-range"] && !Shopify.designMode) return;
  try {
    
  const bindAdRangeThumbs = () => {
    document.querySelectorAll('[data-ad-range-thumb]').forEach((button) => {
      if (button.dataset.adRangeBound === 'true') return;
      button.dataset.adRangeBound = 'true';
      button.addEventListener('click', () => {
        const root = button.closest('.anywell-ad-range');
        const main = root && root.querySelector('[data-ad-range-main]');
        const full = button.getAttribute('data-full');
        if (!main || !full) return;
        main.src = full;
        main.alt = button.getAttribute('data-alt') || '';
        main.removeAttribute('srcset');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAdRangeThumbs);
  } else {
    bindAdRangeThumbs();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anywell-unified-faq"] && !Shopify.designMode) return;
  try {
    
function initAnywellUnifiedFaq(scope){scope.querySelectorAll('.aw-ufaq').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const index=root.querySelector('.aw-ufaq__index'),list=root.querySelector('.aw-ufaq__list'),scenes=[...root.querySelectorAll('.aw-ufaq__scene')];if(!index||!scenes.length)return;const buttons=[...index.querySelectorAll('button')];buttons.forEach(b=>{if(b.dataset.category!=='all'&&!scenes.some(s=>s.dataset.category.split(' ').includes(b.dataset.category)))b.hidden=true;});const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const catOf=s=>s.dataset.category.split(' ');const apply=(cat,scroll)=>{const isAll=cat==='all';buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===cat)));scenes.forEach(s=>{s.hidden=!isAll&&!catOf(s).includes(cat);s.open=false;s.querySelectorAll('.aw-ufaq__topic').forEach(topic=>{topic.hidden=!isAll&&topic.dataset.topicCategory!==cat;topic.open=false;});});const visible=scenes.filter(s=>!s.hidden);if(scroll&&visible.length)list.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});};buttons.forEach(button=>button.addEventListener('click',()=>apply(button.dataset.category,true)));apply('all',false);});}
initAnywellUnifiedFaq(document);document.addEventListener('shopify:section:load',event=>initAnywellUnifiedFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-model-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-model-compare')) customElements.define('aw-model-compare', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.source = [...this.querySelectorAll('[data-source]')];
    this.controls = this.querySelector('[data-controls]');
    this.result = this.querySelector('[data-result]');
    this.selects = [...this.querySelectorAll('select')];
    this.status = this.querySelector('[role=status]');
    this.diff = this.querySelector('[data-differences]');
    if (!this.source.length) { this.status.textContent = this.dataset.empty; return; }
    this.controls.hidden = false;
    this.querySelector('[data-fallback]').hidden = true;
    const query = new URLSearchParams(location.hash.replace(/^#/, ''));
    const choices = (query.get('aw_compare') || this.dataset.default || '').split(',');
    this.selects.forEach((select, index) => {
      select.value = this.source.some(item => item.dataset.id === choices[index]) ? choices[index] : '';
      select.addEventListener('change', () => this.update());
    });
    this.diff.addEventListener('change', () => this.filter());
    this.querySelector('[data-clear]').addEventListener('click', () => {
      this.selects.forEach(item => { item.value = ''; });
      this.update(); this.selects[0].focus();
    });
    this.update(false);
  }
  el(tag, text, className) {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  field(source, key) { return source.querySelector('[data-field="' + key + '"]'); }
  text(source, key) { return this.field(source, key).querySelector('dd').textContent; }
  known(source, key) { return this.field(source, key).dataset.known === 'true'; }
  support(text) {
    const link = this.el('a', text);
    link.href = this.dataset.support;
    return link;
  }
  update(save = true) {
    try { this.render(save); }
    catch {
      this.controls.hidden = true;
      this.querySelector('[data-fallback]').hidden = false;
      this.result.replaceChildren(); this.status.textContent = this.dataset.error;
    }
  }
  render(save) {
    const ids = this.selects.map(item => item.value).filter(Boolean);
    const unique = [...new Set(ids)];
    this.result.replaceChildren();
    if (save) {
      const query = new URLSearchParams(location.hash.replace(/^#/, ''));
      if (unique.length) query.set('aw_compare', unique.join(',')); else query.delete('aw_compare');
      history.replaceState(null, '', location.pathname + location.search + (query.size ? '#' + query.toString() : ''));
    }
    this.diff.disabled = unique.length < 2;
    if (!unique.length) { this.status.textContent = this.dataset.empty; return; }
    const selected = unique.map(id => this.source.find(item => item.dataset.id === id));
    this.status.textContent = ids.length !== unique.length ? this.dataset.duplicate :
      selected.map(item => this.text(item, 'category')).join(' / ');
    const summaries = this.el('div'); summaries.setAttribute('aria-label', this.dataset.summary);
    const cards = this.el('div', '', 'aw-card-grid');
    const details = this.el('details'); details.append(this.el('summary', this.dataset.full));
    for (const source of selected) {
      const card = source.querySelector('[data-card]').cloneNode(true);
      const link = card.querySelector('a'); const url = new URL(link.href, location.href);
      url.hash = 'aw_compare=' + unique.join(','); link.href = url.toString(); cards.append(card);
    }
    for (const field of this.source[0].querySelectorAll('[data-field]')) {
      const key = field.dataset.field;
      const isSummary = ['seat', 'transport', 'range'].includes(key);
      const anyKnown = selected.some(item => this.known(item, key));
      if (!isSummary && (!anyKnown || ['category', 'conditions'].includes(key))) continue;
      const row = this.el('section', '', 'aw-row'); row.dataset.row = key;
      row.append(this.el('h3', field.querySelector('dt').textContent));
      if (!anyKnown) {
        row.append(this.el('p', key === 'transport' ? this.dataset.loading : this.dataset.ask));
      } else {
        const pair = this.el('div', '', 'aw-pair');
        for (const source of selected) {
          const cell = this.el('div', '', 'aw-cell');
          const value = this.known(source, key) ? this.text(source, key) : this.dataset.ask;
          cell.append(this.el('b', source.dataset.name), this.el('span', value));
          pair.append(cell);
        }
        row.append(pair);
      }
      if (key === 'seat') row.append(this.el('p', this.dataset.seatnote, 'aw-caption'));
      if (key === 'range' && anyKnown) row.append(this.el('p', this.text(selected.find(item => this.known(item, 'range')), 'conditions'), 'aw-caption'));
      row.dataset.same = String(selected.length === 2 && selected.every(item => this.known(item, key)) &&
        this.text(selected[0], key) === this.text(selected[1], key));
      (isSummary ? summaries : details).append(row);
    }
    const questions = this.el('section', '', 'aw-questions');
    questions.append(this.el('h3', this.dataset.questions));
    for (const source of selected) {
      const missing = [...source.querySelectorAll('[data-field][data-known=false]')]
        .map(field => field.querySelector('dt').textContent);
      if (missing.length) {
        questions.append(this.el('b', source.dataset.name), this.el('p', missing.join('; ')));
      }
    }
    questions.append(this.support(this.dataset.contact)); details.append(questions);
    const loadMissing = selected.filter(item => !this.known(item, 'capacity'));
    const caution = this.el('div', '', 'aw-note'); caution.dataset.purchaseCheck = '';
    if (loadMissing.length) caution.append(this.el('p', this.dataset.capacity + ' ' + loadMissing.map(item => item.dataset.name).join(' / ')));
    caution.append(this.support(this.dataset.contact));
    this.result.append(summaries, caution, cards, details); this.filter();
  }
  filter() {
    const enabled = this.diff.checked && !this.diff.disabled;
    for (const row of this.result.querySelectorAll('[data-row]')) row.hidden = enabled && row.dataset.same === 'true';
  }
});


  } catch(e) { console.error(e); }
})();
})();
